import { render, staticRenderFns } from "./search-article.vue?vue&type=template&id=386b3a6f&scoped=true"
import script from "./search-article.vue?vue&type=script&lang=js"
export * from "./search-article.vue?vue&type=script&lang=js"
import style0 from "./search-article.vue?vue&type=style&index=0&id=386b3a6f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b3a6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('386b3a6f')) {
      api.createRecord('386b3a6f', component.options)
    } else {
      api.reload('386b3a6f', component.options)
    }
    module.hot.accept("./search-article.vue?vue&type=template&id=386b3a6f&scoped=true", function () {
      api.rerender('386b3a6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/search-article/search-article.vue"
export default component.exports